module.exports = __webpack_public_path__ + "static/img/7.c44071b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/7.png
// module id = Dhkx
// module chunks = 0